import { FormikProps } from "formik";
import { convertHoursIntoSeconds, convertSecondsToHoursAndMinutes, dateToInitial, _formatDate } from "../../../libs/dateUtils";
import { Points, PointsByDayRange, TimeSheetProps } from "../model";

function removeNullValue(value: TimeSheetProps, id: number) {
  let cacheProjectId: number = 0;
  const points = value?.points?.map((point: Points) => {
    if (point?.projectId) cacheProjectId = point?.projectId;
    if (!point?.projectId) {
      point.projectId = Number(cacheProjectId);
      return point;
    } else {
      point.projectId = Number(point?.projectId);
      return point;
    }
  });
  value["points"] = points;
  value["userId"] = id;
  return value;
}

function addNullValue(value: TimeSheetProps) {
  let cacheProjectId: number = 0;
  const points = value.points?.map((point: Points) => {
    if (point.projectId !== cacheProjectId) {
      point["projectId"] = Number(point.projectId);
      if (point.projectId) cacheProjectId = point.projectId;
      return point;
    }
    point["projectId"] = null;
    return point;
  });
  value["points"] = points;
  return value;
}

function refactorVariable(props: FormikProps<TimeSheetProps>) {
  const lastPositionArray: number = props.values.points?.length - 1;
  const arrayPoints = props.values.points;
  const lastFieldExit = arrayPoints[lastPositionArray].exit;
  const firstFieldEntrance = arrayPoints[lastPositionArray].entrance;
  return { lastPositionArray, arrayPoints, lastFieldExit, firstFieldEntrance };
}

function validationFieldExit(props: FormikProps<TimeSheetProps>) {
  const { lastFieldExit } = refactorVariable(props);
  return lastFieldExit;
}

function validationWorkTime(workedTime: any) {
  const workedTimeNumber = +workedTime?.replaceAll(':', '.')
  const warningTime = 7;
  const dangerTime = 9;
  let validation: string = "bg-green-200 text-green-800 rounded-lg p-2";
  if (workedTimeNumber <= warningTime) validation = "bg-yellow-200 text-yellow-800 rounded-lg p-2";
  if (workedTimeNumber >= dangerTime) validation = "bg-red-200 text-red-800 rounded-lg p-2";
  return validation;
}

function isErrorFormField(dataForm: any) {
  let countError = 0;
  dataForm.points?.forEach((item: any) => {
    if (!item?.projectId || !item?.entrance) return countError++;
  });
  return Boolean(countError);
}

function treatFieldsToSave(value: TimeSheetProps, userId: number) {
  const data = removeNullValue(value, userId);
  const dataForm = treatLastField(data);
  return dataForm;
}

function treatLastField(dataForm: TimeSheetProps) {
  const lastField = dataForm.points[dataForm.points?.length - 1].exit;
  if (lastField === null || lastField?.length > 0) {
  } else {
    dataForm.points[dataForm.points?.length].exit = null;
  }
  return dataForm;
}

// function calcTotalHours(list: PointsByDayRange[]) {
//   let amount = 0;
//   list.forEach((element) => {
//     amount = amount + convertHoursIntoSeconds(element.workedTime);
//   });
//   console.log(list);
//   return convertSecondsToHoursAndMinutes(amount).toString();
// }

function calcTotalHours(list: PointsByDayRange[]) {
  const amount = list?.map((element) => element.workedTime).reduce((acc, current) => acc + convertHoursIntoSeconds(current), 0);

  return convertSecondsToHoursAndMinutes(amount).toString();
}

function calcTotalHoursInSeconds(list: PointsByDayRange[]) {
  const currentDateFormated = _formatDate(dateToInitial);
  const amount = list
    ?.map((element) => {
      if (element.date !== currentDateFormated) return element.workedTime;
    })
    .reduce((acc, current) => acc + convertHoursIntoSeconds(current), 0);

  return amount;
}

export {
  addNullValue,
  removeNullValue,
  refactorVariable,
  validationFieldExit,
  validationWorkTime,
  isErrorFormField,
  treatFieldsToSave,
  calcTotalHours,
  calcTotalHoursInSeconds,
};
